export default __webpack_public_path__ + "static/media/download.5bad0c43.png";